import styled from 'styled-components';
import { Modal } from '@/components/uielements/modal';
import { PrimaryButton } from '@/components/uielements/primaryButton/styles';

export const ModalContent = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 32px 24px 32px;
`;

export const DeleteModalHeader = styled.div`
  font-weight: bold;
  display: flex;
  padding: 44px 10px 0px 0px;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  font-size: 16px;
`;

export const ConfirmationModalHeader = styled(DeleteModalHeader)`
  padding-bottom: 24px;
`;

export const ModalBody = styled.div`
  text-align: center;
`;

export const ModalFooter = styled(Modal.Footer)`
  border: none;
  flex-direction: column;
  padding-bottom: 24px;
`;

export const DeleteButton = styled(PrimaryButton)`
  background-color: #da1e28;
  color: white;
  width: 100%;
`;

export const ConfirmationButton = styled(PrimaryButton)`
  color: white;
  width: 100%;
`;
